module.exports = __webpack_public_path__ + "media/sunrise.a07e943f.mp4";